"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteVariantCommand = void 0;
const AbstractFilteredVariantsCommand_1 = require("./AbstractFilteredVariantsCommand");
const SearchVariantsCommand_1 = require("./SearchVariantsCommand");
class DeleteVariantCommand extends AbstractFilteredVariantsCommand_1.AbstractFilteredVariantsCommand {
    async exec() {
        return Promise.all((await new SearchVariantsCommand_1.SearchVariantsCommand(this.api, this.appId).withFilter(this.filter).execute()).map(variant => this.api.delete(`/applications/${this.appId}/${variant.type}/${variant.variantID}`).then(() => variant)));
    }
}
exports.DeleteVariantCommand = DeleteVariantCommand;
//# sourceMappingURL=DeleteVariantCommand.js.map